// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.quest__quest-container {\n  margin: 0;\n  padding: 0;\n  height: 100%;\n}\n.vue-friendly-iframe {\n  height: 100%;\n}\niframe {\n  width: 100%;\n  height: 100%;\n  position: static !important;\n  visibility: visible !important;\n}\n", ""]);
// Exports
module.exports = exports;
